import React from 'react'

import Box from '@mui/material/Box'
import { useIntl } from 'react-intl'

import getContentType from './getContentType'
import IconButton from '../Button/IconButton'
import type { UserRole } from '../modals/ModalShareLoan'
import ShareLoanActionsIcon from './ShareLoanActionsIcon'

type ShareLoanActionsCellProps = {
	row: UserRole
	userId: string
	isSubmitting?: boolean
	onRevokeUser: (userId: string) => void
}

const ShareLoanActionsCell = ({
	row,
	userId,
	isSubmitting,
	onRevokeUser,
}: ShareLoanActionsCellProps) => {
	const { formatMessage } = useIntl()

	const title = formatMessage({
		id: row.markedForDeletion
			? 'share_loan.restore_user'
			: 'share_loan.remove_user',
	})

	const buttonColor = row.markedForDeletion ? 'warning' : 'error'
	const contentType = getContentType(row)
	const disabledIconButton =
		row.loadingRevoke ||
		row.loadingEdit ||
		userId === row.user.id ||
		isSubmitting

	const handleRevokeUser = () => onRevokeUser(row.user.id)

	return (
		<Box sx={{ display: 'flex', gap: 1 }}>
			<IconButton
				title={title}
				size="small"
				color={buttonColor}
				onClick={handleRevokeUser}
				disabled={disabledIconButton}
			>
				<ShareLoanActionsIcon contentType={contentType} />
			</IconButton>
		</Box>
	)
}

export default ShareLoanActionsCell
